import axios from "axios";
import cookie from "js-cookie";

// Saves a token the way Login.jsx does, so the rest of the app picks it up.
export const saveSession = (token, user) => {
  cookie.set("token", token, { expires: 0.9 });
  cookie.set("type", "user", { expires: 0.9 });
  if (user) {
    cookie.set("name", `${user.firstName || ""} ${user.lastName || ""}`.trim());
    cookie.set("id", user._id);
  }
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

// Logs into one of the person's companies and opens the dashboard.
export const enterCompany = async ({ userId, accountId }) => {
  const res = await axios.patch("/root/switch", { userId, accountId });
  saveSession(res.data.token, res.data.user);
  window.location.replace("/dashboard");
};

// An invite's company code, kept from the sign-up link (?joinCode=) until the
// person reaches the join step. localStorage, not sessionStorage: the login
// link they're emailed usually opens in a new tab.
const INVITE_CODE_KEY = "inviteJoinCode";
export const rememberInviteCode = (code) => {
  try {
    if (code) localStorage.setItem(INVITE_CODE_KEY, code);
  } catch {}
};
export const getInviteCode = () => {
  try {
    return localStorage.getItem(INVITE_CODE_KEY) || "";
  } catch {
    return "";
  }
};
export const clearInviteCode = () => {
  try {
    localStorage.removeItem(INVITE_CODE_KEY);
  } catch {}
};
